<h1 matHeader>
    Clients
</h1>
<ngx-datatable style="margin-top: 15px;" #tableNew class='material' [columnMode]="'force'" [headerHeight]="50"
    [footerHeight]="50" [rowHeight]="40" [limit]="25" [rows]="customers">
    <ngx-datatable-column [maxWidth]="150" name="Name" prop="name"></ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="150" name="Email" prop="email"></ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="150" name="Age" prop="age"></ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="150" name="Country" prop="country"></ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="150" name="Interest" prop="interest"></ngx-datatable-column>
</ngx-datatable>